import "./RFxEvaluation.scss";
import Summary from "./Summary";
import {
  ToggleButton,
  ToggleButtonGroup,
  Avatar,
  Tooltip as MUITooltip,
  IconButton,
} from "@mui/material";

import downloadSvg from "../../../../assets/DownLoadScore.svg";
import infoIconSvg from "../../../../assets/images/UserTable/InfoIcon.svg";
import RightArrowSvg from "../../../../assets/RightArrow.svg";
import LeftArrowSvgForCarousel from "../../../../assets/ArrowLeft.svg";
import bookSparkSvg from "../../../../assets/book_spark.svg";
import arrowDropDownSvg from "../../../../assets/arrow_drop_down.svg";
import arrowUpSvg from "../../../../assets/arrowUp.svg";
import searchSvg from "../../../../assets/search.svg";
import starGif from "../../../../assets/images/star.gif";
import PdfIconSvg from "../../../../assets/pdfIcon.svg";
import ThumbUpSvg from "../../../../assets/thumb_up.svg";
import ThumbDownSvg from "../../../../assets/thumb_down.svg";
import inforIconBlueSvg from "../../../../assets/info_presentation.svg";
import closeIconSvg from "../../../../assets/close_icon_blue.svg";

import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb";
import { ROUTES } from "../../../../common/constants";
import Tabs from "../../../../components/Tabs/Tabs";
import { tabsForRfxEvaluation } from "../../constants";
import Typography from "../../../../components/Typography/Typography";
import { DoughnutChart } from "../../../../components/Charts/Charts";
import EllipsesText from "../../components/EllipsisText/EllipsisText";
import { useRfxHook } from "../../../../hooks/rfx_evaluation";
import Tooltip from "../../../../components/Tooltip/Tooltip";

const RFxEvaluation = () => {
  const {
    dataForChart,
    chartBottomData,
    visibleFiles,
    parameters,
    pointsGot,
    files,
    handleBackwardClick,
    handleFileSelect,
    handleForwardClick,
    selectedFileData,
    handleToggleClick,
    activeToggle,
    dropdownOpen,
    currentFileIndex,
    selectedTab,
    setSelectedTab,
    summaryData,
    pointsTotal,
    isPresentation,
    showPresentationBanner,
    setShowPresentationBanner,
    fileIdForShowingStar,
  } = useRfxHook();
  return (
    <div className="rfx-container">
      <Breadcrumb
        list={[
          {
            text: "RFx Evaluation",
            link: ROUTES.rfxEvaluationDashboard,
          },
        ]}
      />
      <div className="rfx-mainContent">
        <div className="rfx_evaluation">
          <div className="header">
            <div className="header-left">
              <h1 className="gradient-text">RFx Evaluation</h1>
              <p className="sub-header">
                Evaluation score for Responses uploaded for the RFP
              </p>
            </div>
            <div className="header-right">
              <div className="toggle-buttons-wrapper">
                <ToggleButtonGroup
                  value={activeToggle}
                  exclusive
                  onChange={handleToggleClick}
                  aria-label="Score Card and Summary Toggle"
                  sx={{
                    border: "1px solid #2E64DE",
                    borderRadius: "20px",

                    "& .MuiToggleButtonGroup-grouped": {
                      borderRadius: "20px",
                      border: "none",
                      "&:not(:first-of-type)": {
                        borderRadius: "20px",
                      },
                      "&:not(:last-of-type)": {
                        borderRadius: "20px",
                      },
                    },
                    padding: "0.225rem",
                  }}
                >
                  <MUITooltip
                    title="View the detailed score card"
                    placement="bottom-end"
                    arrow
                  >
                    <ToggleButton
                      value="Score Card"
                      sx={{
                        padding: "2px",
                        width: "100px",
                        textTransform: "capitalize",
                        "&.Mui-selected": {
                          color: "#1976d2",
                          backgroundColor: "rgba(25, 118, 210, 0.08)",
                        },
                      }}
                    >
                      Score Card
                    </ToggleButton>
                  </MUITooltip>
                  <MUITooltip
                    title="View the summary of the evaluation"
                    placement="bottom-end"
                    arrow
                  >
                    <ToggleButton
                      value="Summary"
                      sx={{
                        padding: "2px",
                        width: "100px",
                        textTransform: "capitalize",
                        "&.Mui-selected": {
                          color: "#1976d2",
                          backgroundColor: "rgba(25, 118, 210, 0.08)",
                        },
                      }}
                    >
                      Summary
                    </ToggleButton>
                  </MUITooltip>
                </ToggleButtonGroup>
              </div>
            </div>
          </div>

          <div className="rfx-scrollable-content">
            <div className="carousel-tabs-container">
              <div className="carousel-tabs">
                {currentFileIndex > 0 && (
                  <IconButton onClick={handleBackwardClick}>
                    <img src={LeftArrowSvgForCarousel} alt="Left Arrow" />
                  </IconButton>
                )}
                {visibleFiles?.map((file) => (
                  <EllipsesText
                    tooltipContent={file?.fileName}
                    style={{
                      maxWidth: "180px",
                      overflow: "visible",
                      textOverflow: "visible",
                    }}
                  >
                    <div
                      className={`rfx_fileFlag ${
                        file?.id === selectedFileData.id ? "active_file" : ""
                      }`}
                      onClick={() => handleFileSelect(file?.id)}
                    >
                      <img
                        src={PdfIconSvg}
                        alt="Pdf Icon"
                        className="pdf-icon"
                        width={16}
                        height={16}
                      />
                      <p>{file?.fileName}</p>
                      {fileIdForShowingStar === file?.id && (
                        <div className="star_gif">
                          <img src={starGif} alt="" />
                        </div>
                      )}
                    </div>
                  </EllipsesText>
                ))}
                {currentFileIndex + 3 < files?.length && (
                  <IconButton onClick={handleForwardClick}>
                    <img src={RightArrowSvg} alt="Right Arrow" />
                  </IconButton>
                )}
              </div>

              <div
                className="upload-button"
                // ref={dropdownRef}
              >
                {!dropdownOpen ? (
                  <button
                  // onClick={handleDropdownClick}
                  >
                    Documents Uploaded
                    <span className="spacer"></span>
                    <img
                      src={arrowDropDownSvg}
                      alt="Arrow Down"
                      className="dropdown-arrow"
                    />
                  </button>
                ) : (
                  <button
                    // onClick={handleDropdownClick}
                    className="SearchPlaceholder"
                  >
                    {/* <img src={searchSvg} alt="Search Icon" className="search-icon" /> */}
                    Search Documents
                    <span className="spacer"></span>
                    <img
                      src={arrowUpSvg}
                      alt="Arrow Up"
                      className="dropdown-arrow"
                    />
                  </button>
                )}
                {dropdownOpen && (
                  <div className="dropdown-content">
                    <div className="search-bar">
                      <img
                        src={searchSvg}
                        alt="Search Icon"
                        className="search-icon"
                      />
                      <input
                        type="text"
                        placeholder="Search documents"
                        className="SearchPlaceholder"
                      />
                    </div>
                    {files.map((file, index) => (
                      <div
                        key={index}
                        className={`dropdown-item ${
                          index === 0 ? "selected" : ""
                        }`}
                        onClick={() => handleFileSelect(file?.id)}
                      >
                        <img
                          src={downloadSvg}
                          alt="Download Icon"
                          className="download-icon"
                        />
                        <span className="file-name">{file?.fileName}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="content">
              {activeToggle === "Score Card" ? (
                <>
                  <div className="scorecard">
                    <Typography
                      fontSize="14px"
                      fontWeight={600}
                      lineHeight="24px"
                      color="#000000CC"
                    >
                      Brand Agency Evaluation Scorecard
                    </Typography>

                    <div className="chart-container">
                      <DoughnutChart data={dataForChart} />
                    </div>
                    <div className="score-details">
                      <div className="how_to_use">
                        <p>How to use </p>
                        <Tooltip
                          placement="right"
                          title={
                            <Typography
                              fontSize="12px"
                              fontWeight={400}
                              lineHeight="16px"
                            >
                              The chart shows the total score for the RFP
                              measured across defined parameters. Select the
                              parameter to know in detail about the score
                              calculated.
                            </Typography>
                          }
                        >
                          <img
                            src={infoIconSvg}
                            alt="Info Icon"
                            width={14}
                            height={14}
                          />
                        </Tooltip>
                      </div>
                      <ul>
                        {chartBottomData?.map((chartTextData) => {
                          return (
                            <li className="score-item">
                              <span
                                className="circle"
                                style={{
                                  backgroundColor: chartTextData.color,
                                }}
                              ></span>
                              <span className="title">
                                {chartTextData.text}
                              </span>
                              <span className="score">
                                {chartTextData.score}
                              </span>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>

                  <div className="evaluation-details">
                    <Tabs
                      tabs={tabsForRfxEvaluation}
                      value={selectedTab}
                      handleTabClick={(_: any, tab: any) => {
                        setSelectedTab(tab);
                      }}
                      tabsWidth="100%"
                      key="rfx_evulation_tabs"
                    />
                    <div className="details">
                      <div className="header">
                        <div className="header-left">
                          <Avatar
                            sx={{
                              bgcolor: "#fff",
                              color: "#0E9D58",
                              border: "2px solid #0E9D58",
                              fontFamily: "Google Sans, sans-serif",
                              fontWeight: 500,
                              fontSize: "12px",
                              lineHeight: "120%",
                              letterSpacing: "0px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "40px", // Adjust width and height as needed
                              height: "40px",
                            }}
                          >
                            {`${pointsGot || 0}/${(pointsTotal || 0) * 2}`}
                          </Avatar>
                          <div className="text-container">
                            <Typography
                              fontSize="14px"
                              fontWeight={600}
                              color="#000000CC"
                            >
                              {tabsForRfxEvaluation[selectedTab]?.text}
                            </Typography>
                            <Typography
                              fontSize="12px"
                              fontWeight={400}
                              color="#00000099"
                            >
                              {tabsForRfxEvaluation[selectedTab]?.subText}
                            </Typography>
                          </div>
                        </div>
                        <a href="#" className="download">
                          <img src={downloadSvg} alt="Download Icon" /> Download
                          Scorecard
                        </a>
                      </div>
                      {/* className="table-container" */}
                      <div
                        className={`table-container ${
                          selectedTab === 3 && showPresentationBanner
                            ? "table-container-with-banner"
                            : ""
                        }`}
                      >
                        <table>
                          <thead>
                            <tr>
                              <th className="Parameter">Parameter</th>
                              <th className="Description">Description</th>
                              <th className="score-column">
                                <span className="score-text">
                                  Score
                                  <img
                                    className="ScoreIcon"
                                    src={infoIconSvg}
                                    alt="Info Icon"
                                  />
                                </span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {parameters?.map((parameter: any) => {
                              return (
                                <tr>
                                  <td>{parameter?.point}</td>
                                  <td
                                    style={{
                                      maxWidth: "200px",
                                      width: "150px",
                                    }}
                                  >
                                    {parameter?.description}
                                  </td>
                                  <td>{parameter?.score}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      {isPresentation && showPresentationBanner && (
                        <div className="presentation_banner_wrapper">
                          <PresentationBanner
                            setShowPresentationBanner={
                              setShowPresentationBanner
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="evaluation-summary-heading">
                    <div className="textHeader">
                      <img
                        src={bookSparkSvg}
                        alt="Book Spark Icon"
                        className="book-svg"
                      />
                      <Typography
                        fontSize="12px"
                        fontWeight={400}
                        color="#000000CC"
                      >
                        Evaluation Summary
                      </Typography>
                    </div>
                    <div className="summary-container">
                      <Summary summarydata={summaryData} />
                    </div>
                    <div className="feedback-icons">
                      <img
                        src={ThumbUpSvg}
                        alt="Thumb Up"
                        className="thumb-icon"
                      />
                      <img
                        src={ThumbDownSvg}
                        alt="Thumb Down"
                        className="thumb-icon"
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const PresentationBanner = ({ setShowPresentationBanner }: any) => {
  return (
    <div className="presentation_banner">
      <div className="left_side">
        <img src={inforIconBlueSvg} alt="" height={20} width={20} />
        <Typography
          fontSize="12px"
          fontWeight={400}
          lineHeight="14px"
          color="#101113"
        >
          The score for this section will be calculated after the presentations
          are completed and the user has submitted their presentation notes or
          scorecards.
        </Typography>
      </div>
      <div className="right_side">
        <IconButton onClick={() => setShowPresentationBanner(false)}>
          <img src={closeIconSvg} alt="" height={20} width={20} />
        </IconButton>
      </div>
    </div>
  );
};

export default RFxEvaluation;
